import request from 'utils/request'
import { MCBQS010InitRequest } from 'types/MCBQS010/MCBQS010InitRequest'
import { MCBQS010DowloadFlieRequest } from 'types/MCBQS010/MCBQS010DowloadFlieRequest'

// 初期表示処理
export const initRequest = (params: MCBQS010InitRequest) =>
request({
    url: `MCBQS010/init`,
    method: 'post',
    data: params,
})

// 「出力する」ボタン押下
export const dowloadFlieRequest = (params: MCBQS010DowloadFlieRequest) =>
request({
    url: `MCBQS010/dowloadFlie`,
    method: 'post',
    data: params,
})
